<app-form-schema-renderer *ngIf="resolvedSchema && data"
	[property]="[]" [schema]="resolvedSchema" [readonly]="false" [data]="data"
	(emitFormSubmit)="createNewProject($event)" [formID]="projectFormID"
	(emitFormValid)="setSubmitActive($event)"
>
</app-form-schema-renderer>
<div nz-row [nzJustify]="'space-between'">
	<div nz-col>
		<div nz-row [nzGutter]="[16, 6]">
			<div nz-col>
				<app-splitbutton [elements]="[projectCancelSplitButton]"></app-splitbutton>
			</div>
		</div>
	</div>
	<div nz-col>
		<div nz-row [nzJustify]="'end'" [nzGutter]="[16, 6]">
			<div nz-col>
				<app-splitbutton *ngIf="resolvedSchema && data"
								[elements]="[projectAddSplitButton]">
				</app-splitbutton>
			</div>
		</div>
	</div>
</div>
